import styled from "styled-components";
import { colors } from "../../../../../../consts";
import { Paragraph2, WrapperContainer } from "../../../../../../components";

export const OverviewSectionSummaryStyled = styled(WrapperContainer)`
  ${Paragraph2} {
    word-break: break-all;
  }
`;

export const InfoText = styled(Paragraph2)`
  font-size: 10px;
  line-height: 14px;
  color: ${colors.RAISIN_70};
  text-transform: uppercase;
`;
